import { Reveal, OceanTag } from "./kit";
import { OCEAN_WORKSTREAMS } from "../../data/oceanContent";

export default function OceanWorkProgramme() {
  return (
    <section id="programme" data-testid="ocean-programme-section" className="relative py-24 lg:py-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <OceanTag index="03" label="Scientific Work Programme" />
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-oseaglass leading-[0.95] max-w-3xl">
            Five proposed <span className="text-oreef">workstreams</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-oseaglass/70 leading-relaxed">
            Proposed activities only — subject to scientific collaboration, technical feasibility and all required
            permissions. Every result would be independently confirmed before any claim is made.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-5">
          {OCEAN_WORKSTREAMS.map((ws, i) => (
            <Reveal key={ws.code} delay={0.05 * i}>
              <article className="h-full border border-oreef/15 bg-oabyss/40 p-7 hover:border-oreef/40 transition-colors duration-300" data-testid={`workstream-${i}`}>
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-sm text-ocoral tracking-[0.2em] shrink-0">{ws.code}</span>
                  <h3 className="font-display font-semibold text-xl sm:text-2xl text-oseaglass tracking-wide leading-tight">{ws.title}</h3>
                </div>
                <ul className="mt-5 space-y-2.5">
                  {ws.items.map((it) => (
                    <li key={it} className="text-sm text-oseaglass/70 flex gap-3 leading-relaxed">
                      <span className="text-oreef shrink-0 mt-0.5">▸</span>{it}
                    </li>
                  ))}
                </ul>
                {ws.note && (
                  <p className="mt-5 pt-4 border-t border-oslate/15 text-xs font-mono text-ogold/90 leading-relaxed tracking-wide">{ws.note}</p>
                )}
              </article>
            </Reveal>
          ))}
          <Reveal delay={0.25}>
            <div className="h-full border border-ocoral/25 bg-ocoral/5 p-7 flex flex-col justify-center" data-testid="programme-disclaimer">
              <div className="font-mono text-[10px] tracking-[0.3em] text-ocoral mb-3">SCIENTIFIC INTEGRITY</div>
              <p className="text-sm text-oseaglass/75 leading-relaxed">
                No model accuracy, species-detection performance, water-quality measurements or bathymetric surveys are
                claimed. Opportunistic sightings are distinct from systematic biodiversity surveys, and exploratory
                visualisations are distinct from validated analytical products.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
